import { connect } from 'react-redux';
import * as R from 'ramda';
import { getItem, setBolDate } from '../../store/rackWaitTimesSlice';
import BolHistory from './BolHistory';

const mapState = R.applySpec({
  bolDate: getItem('bolDate'),
  bolHistory: getItem('bolHistory'),
});

const mapDispatch = {
  setBolDate,
};

export default connect(mapState, mapDispatch)(BolHistory);
